import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
export default function ProjektStatusPausiert({
   selectedEstates, setSelectedEstates
}) {

   function abbrechen(){
setSelectedEstates(false)
   }
   return (
      <>
         <Modal show={selectedEstates} size="xl" onHide={abbrechen}>
            <Modal.Header closeButton>
               <Modal.Title>{selectedEstates&&selectedEstates.heading}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <ol>
                  {selectedEstates&&selectedEstates.estates.map((estateIte,index)=>{

                     return(<li>
                        {estateIte.objektbezeichnung?<a target="_blank" href={"/datenblatt?estateid="+estateIte.id}>{estateIte.objektbezeichnung}</a>:<span>{estateIte.objektnr_extern}</span>} {estateIte.statusdatum_pausiert&&estateIte.statusdatum_pausiert!=="0000-00-00"&&<span>({new Date(estateIte.statusdatum_pausiert).toLocaleDateString()})</span>}
                     </li>)
                  }
                  )}
                  </ol>
               
            </Modal.Body>
            <Modal.Footer>
               <Button variant="secondary" onClick={abbrechen}>
                  Schließen
               </Button>
               
            </Modal.Footer>
         </Modal>
      </>
   );
}
